module.exports = __webpack_public_path__ + "img/product_recommend_banner.2f5fae12.png";